import { createContext, useContext, useState } from "react";
import CustomSnackbar from "../components/CustomSnackbar";
import { localizedErrorMessage } from "../utils/italianErrorMessage";

const SnackbarContext = createContext();
export const SnackbarProvider = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        type: "info"
    });

    const showSnackbar = (message, type = "info") => {
        const displayedMessage = ["error", "warning"].includes(type)
            ? localizedErrorMessage(message)
            : message;
        setSnackbar({
            open: true,
            message: displayedMessage,
            type
        });
    };

    const closeSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                type={snackbar.type}
                onClose={closeSnackbar}
            />
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => useContext(SnackbarContext);
